export type GameTypeConfig = {
  name: string;
  auth_groups: string[];
  enabled: boolean;
  data: object;
};

export const gameTypeDefaultValues = {
  name: "",
  auth_groups: [],
  enabled: true,
  data: {},
}
